/**
 * CoachPlaybook - Entry Point
 * Version: 0.6.0
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SportProvider } from './components/common/SportContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SportProvider>
      <App />
    </SportProvider>
  </React.StrictMode>
);
